<template>
  <v-breadcrumbs :items="crumbs" divider=">">
    <v-breadcrumbs-item
      :disabled="isCurrentRoute(item.to)"
      slot="item"
      slot-scope="{ item }"
      exact
      :to="item.to"
      >{{ item.text }}</v-breadcrumbs-item
    >
  </v-breadcrumbs>
</template>

<script>
export default {
  computed: {
    crumbs: function () {
      return this.$route.meta.breadCrumbs;
    },
  },

  methods: {
    isCurrentRoute(toName) {
      return this.$route.name == toName.name;
    },
  },
};
</script>

<style scoped>
</style>